import o from "./browser/index.es.js";
import * as t from "./common/utils.es.js";
const m = {
  ...t,
  ...o
};
export {
  m as default
};
